/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Attribute_ManufacturerInputs */

const en_attribute_manufacturer = /** @type {(inputs: Attribute_ManufacturerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manufacturer`)
};

/**
* | output |
* | --- |
* | "Manufacturer" |
*
* @param {Attribute_ManufacturerInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const attribute_manufacturer = /** @type {((inputs?: Attribute_ManufacturerInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Attribute_ManufacturerInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_attribute_manufacturer(inputs)
});